
<router-outlet></router-outlet>

<ngx-spinner bdColor = "rgb(0,138,132)" size = "medium" color = "#ffffff" type = "ball-atom" [fullScreen] = "true"><p style="color: white" > Cargando... </p></ngx-spinner>